class OneSignal {
    constructor() {
    }
    domInjection(appId) {
        let libScript = this.createLibaryScript();
        let initScript = this.createInitLibaryScript(appId);

        this.appendElementToBody(libScript);
        this.appendBodyElementToBody(initScript);
    }
    appendElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
    appendBodyElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
    createLibaryScript() {
        let newScriptElement = document.createElement("script");

        newScriptElement.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
        newScriptElement.type = 'text/javascript';
        newScriptElement.async = false;
        newScriptElement.defer = false;

        return newScriptElement;
    }
    createInitLibaryScript(appId) {
        return this.createInitializationScript(appId);
    }
    createInitializationScript(appId) {
        let newScriptElement = document.createElement("script");

        newScriptElement.type = 'text/javascript';

        let textN = document.createTextNode('window.OneSignal = window.OneSignal || [];\n' +
            '      OneSignal.push(function() {\n' +
            '        OneSignal.init({\n' +
            '          appId: "' + appId +'",\n' +
            '        });\n' +
            '      });');

        newScriptElement.appendChild(textN);

        return newScriptElement;
    }
}

export default OneSignal;